import { render, staticRenderFns } from "./form-produto-estoque.vue?vue&type=template&id=6f7232c6&scoped=true&"
import script from "./form-produto-estoque.vue?vue&type=script&lang=js&"
export * from "./form-produto-estoque.vue?vue&type=script&lang=js&"
import style0 from "./form-produto-estoque.vue?vue&type=style&index=0&id=6f7232c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7232c6",
  null
  
)

export default component.exports